export class ReplacementModule {
    public idSupplierRequest: string;
    public idReplacementModule: string;

    constructor(idSupplierRequest?: string
                , idReplacementModule?: string) {
        this.idSupplierRequest = idSupplierRequest;
        this.idReplacementModule = idReplacementModule;
    }
}